// src/view/Starter.js
import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, Link, Popover, TextField, Typography,  } from '@mui/material';
// import { styled } from '@mui/material/styles';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import SearchIcon from '@mui/icons-material/Search';
import { SectionTitle, SectionBody, Plain } from './StyledViews';
import MiscValue from '../value/MiscValue';
import { useSnackbar } from 'notistack';
import TickerSelector from './com/TickerSelector';


export default function Starter() {
    const [ticker, setTicker] = useState('KRX:011790'); // SKC
    const [startDate, setStartDate] = useState(MiscValue.getYMD(new Date(), 365*3));
    const [endDate, setEndDate] = useState(MiscValue.getYMD(new Date(), 1));
    const [funcString, setFuncString] = useState('');
    // const [anchorEl, setAnchorEl] = useState(null);
    const [tickerSelector, setTickerSelector] = useState({type:null, anchor: null});
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (ticker && startDate && endDate) {
            const func = `=GOOGLEFINANCE("${ticker}", "all", "${startDate}", "${endDate}")`;
            setFuncString(func);
        }
    }, [ticker, startDate, endDate]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(funcString);
        enqueueSnackbar('함수가 복사되었습니다.', { variant: 'success' });
    };

    const prefixTicker = (prefix) => {
        if(/^\w+:\d{6}$/.test(ticker)) {
            setTicker(`${prefix}:${ticker.split(':')[1]}`);
        }
        else if(/^\d{6}$/.test(ticker)) {
            setTicker(`${prefix}:${ticker}`);
        }
    };

    const renderForm = () => {
        return(
            <Box style={{marginLeft: 16}}>
                <Box style={{display:'flex', alignItems:'center', minWidth: 350}}>
                    <TextField label="종목코드" value={ticker}
                        style={{marginRight: 8, minWidth:80, maxWidth: 160}}
                        placeholder='KRX:011790'
                        onChange={(e) => setTicker(e.target.value)} />
                    <Button
                        variant="contained" onClick={(e) => setTickerSelector({type: 'stock', anchor: e.currentTarget})}
                        startIcon={<SearchIcon />}
                    >
                        주식
                    </Button>
                    <Button
                        variant="contained" onClick={(e) => setTickerSelector({type: 'etf', anchor: e.currentTarget})}
                        startIcon={<SearchIcon />}
                        style={{marginLeft: 8}}
                    >
                        ETF
                    </Button>
                </Box>
                <Box style={{padding:'8px 0px', fontSize: '0.85rem', maxWidth: 350, color: '#577', lineHeight: '1.5rem'}}>
                    -종목 검색 버튼을 사용하면 KRX, KOSDAQ이 붙어 나옵니다.<br/>
                    -찾으시는 종목이 없을 수도 있습니다.
                </Box>
                <Popover
                    open={Boolean(tickerSelector.anchor)}
                    anchorEl={tickerSelector.anchor}
                    onClose={() => setTickerSelector({type: null, anchor: null})}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <TickerSelector type={tickerSelector.type}
                        open={Boolean(tickerSelector.anchor)}
                        onClose={(ticker) => {
                            if(ticker) setTicker(ticker);
                            setTickerSelector({type: null, anchor: null});
                        }}
                    />
                </Popover>
                <Box style={{display:'flex', alignItems:'center', marginTop: 16}}>
                    <TextField label="시작일" type="date" value={startDate} style={{marginRight: 8}}
                        onChange={(e) => {console.log(e.target.value); setStartDate(e.target.value)}} />
                    <TextField label="종료일" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </Box>
            </Box>
        );
    };

    return (
        <Box>
            <SectionTitle label="시작하기: 구글 시트에 함수 입력하기" />
            <SectionBody>
                <Box style={{display:'flex', marginTop: 16}}>
                    <Box style={{flexGrow: 1}}>
                        <Plain>
                            구글시트에 일정 기간의 주가 데이터를 표시하게한 후 그 데이터를 시뮬레이션에 활용하려고 합니다.
                            오른쪽의 종목코드, 시작과 종료일을 입력하시면 구글시트에 입력할 함수를 생성합니다.
                            <br />
                            <Link component="button" onClick={()=>prefixTicker('KRX')} style={{marginRight: 8}}>
                                코스피는 종목코드 앞에 "KRX:"를 붙여야 하고,
                            </Link>
                            <Link component="button" onClick={()=>prefixTicker('KOSDAQ')}>
                                코스닥은 종목코드 앞에 "KOSDAQ:"를 붙여야 합니다.
                            </Link><br/>

                            종목 검색 버튼을 사용하면 KRX, KOSDAQ이 붙어 나옵니다. 하지만, 이 값이 정확한지는 웹마스터도 확신하지는 못하므로 데이터가 나오지 않는 경우 직접 확인해 보시기 바랍니다.<br /><br />
                            기간은 충분히 (3년 정도) 설정해서 분산투자의 효과를 확인해 보세요.
                            <br /><br />
                            이미 함수 사용법을 잘 알고 계시다면, 다음 주가 데이터 붙여넣기 섹션으로 이동하여 데이터 붙여넣기를 하셔도 됩니다.<br/>
                            <span style={{color:'red'}}>(어떤 종목(특히 ETF)은 구글함수로 데이터를 조회할 수 없는 경우도 있습니다)</span>
                        </Plain>
                    </Box>
                    {renderForm()}
                </Box>
                
                <Box style={{marginTop:10}}>
                    <Card>
                        <CardContent style={{backgroundColor:'#cef'}}>
                            {
                                funcString
                                ?
                                <Box onClick={copyToClipboard}>
                                <Typography variant="body2" color="textSecondary">
                                    다음 함수를 구글시트에 입력하세요 - 함수나 아래 버튼을 클릭하여 복사한 후 
                                    구글시트에 붙여넣기 하면 주가데이터가 나타납니다. 작업 편의를 위해 맨 첫줄에 입력하세요.
                                </Typography>
                                <Typography variant="h5" color="primary" style={{padding:10}}
                                >
                                    {funcString}
                                </Typography>
                                </Box>
                                :
                                <Typography variant="body2" color="textSecondary">
                                    종목코드, 시작일, 종료일을 입력하세요.
                                </Typography>
                            }
                        </CardContent>
                        {
                            funcString &&
                            <CardActions
                                style={{backgroundColor:'#dff5ff', alignItems:'center', display:'flex', justifyContent:'center'}}>
                                <Button
                                    variant="contained"
                                    onClick={() => {copyToClipboard()}}
                                    startIcon={<CopyAllIcon />}
                                >
                                    함수를 클립보드에 복사
                                </Button>
                            </CardActions>
                        }
                    </Card>
                </Box>
            </SectionBody>
        </Box>
    );
}

/*

[섹션 1: 시작하기] Starter.js

    입력 필드: Ticker, 시작일, 종료일 (티커는 Google Finance에서 지원하는 형식으로 입력. 코스피, 코스닥의 경우 어떻게 해야하는지 안내 필요. 작은 버튼으로 클릭하면 검사해서 변경해 주기)
    출력 필드: Google Sheets 연동 안내: 사용자가 복사할 수 있도록 =GOOGLEFINANCE(...) 함수를 자동으로 생성하여 보여줍니다.
    버튼: "복사" 버튼을 클릭하면 클립보드에 복사되도록 합니다. 상세한 안내 메시지를 그림과 함께 표시합니다.
    버튼: "다음" 버튼을 클릭하면 "주가 데이터 붙여넣기" 섹션으로 이동.


KB금융 krx:105560
나무가 kosdaq:190510

=GOOGLEFINANCE("KRX:005930", "all", "2022-08-12", "2025-08-10")
*/

